var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 512c141 0 256-115 256-256s-115-256-256-256-256 115-256 256 115 256 256 256z",
    fill: "#ff4646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 81.02h196.7c10.23 0 18.62 8.36 18.62 18.6v268.47c0 10.23-8.39 18.62-18.62 18.62h-196.7c-10.23 0-18.6-8.39-18.6-18.62v-268.48c0-10.23 8.37-18.59 18.6-18.59z",
    fill: "#adb4ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.8 125.32h196.7c10.23 0 18.62 8.36 18.62 18.6v268.47c0 10.23-8.39 18.62-18.62 18.62h-196.7c-10.23 0-18.6-8.39-18.6-18.62v-268.47c.01-10.23 8.37-18.6 18.6-18.6z",
    fill: "#e4f0e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.67 151h32.74c3.17 0 5.78 2.61 5.78 5.78v32.74c0 3.17-2.61 5.78-5.78 5.78h-32.74c-3.17 0-5.78-2.61-5.78-5.78v-32.74c0-3.17 2.61-5.78 5.78-5.78z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.67 221.02h32.74c3.17 0 5.78 2.58 5.78 5.75v32.77c0 3.17-2.61 5.75-5.78 5.75h-32.74c-3.17 0-5.78-2.58-5.78-5.75v-32.77c0-3.17 2.61-5.75 5.78-5.75z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.67 291.01h32.74c3.17 0 5.78 2.61 5.78 5.78v32.74c0 3.17-2.61 5.78-5.78 5.78h-32.74c-3.17 0-5.78-2.61-5.78-5.78v-32.74c0-3.17 2.61-5.78 5.78-5.78z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.67 361h32.74c3.17 0 5.78 2.61 5.78 5.78v32.74c0 3.2-2.61 5.78-5.78 5.78h-32.74c-3.17 0-5.78-2.58-5.78-5.78v-32.74c0-3.18 2.61-5.78 5.78-5.78z",
    fill: "#ff4155"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m264.42 165.09c-4.42 0-7.99-3.57-7.99-7.99s3.57-7.99 7.99-7.99h97.48c4.39 0 7.99 3.57 7.99 7.99s-3.6 7.99-7.99 7.99z",
    fill: "#3c3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m264.42 197.21c-4.42 0-7.99-3.57-7.99-7.99s3.57-7.99 7.99-7.99h97.48c4.39 0 7.99 3.57 7.99 7.99s-3.6 7.99-7.99 7.99z",
    fill: "#3c3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m264.42 235.11c-4.42 0-7.99-3.6-7.99-8.02 0-4.39 3.57-7.99 7.99-7.99h97.48c4.39 0 7.99 3.6 7.99 7.99 0 4.42-3.6 8.02-7.99 8.02z",
    fill: "#3c3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m264.42 267.23c-4.42 0-7.99-3.6-7.99-7.99 0-4.42 3.57-8.02 7.99-8.02h97.48c4.39 0 7.99 3.6 7.99 8.02 0 4.39-3.6 7.99-7.99 7.99z",
    fill: "#3c3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m325.17 292.51c6.01 1.36 11.62 3.74 16.7 6.92l4.45-2.27 7.11-3.63 5.67 5.64 5.67 5.67-3.66 7.11-2.27 4.48c3.17 5.05 5.56 10.66 6.92 16.67l4.76 1.53 7.6 2.47v16.01l-7.6 2.47-4.76 1.56c-1.36 5.98-3.74 11.59-6.92 16.67l2.27 4.45 3.66 7.14-5.67 5.64-5.67 5.67-7.11-3.63-4.45-2.27c-5.07 3.17-10.69 5.53-16.7 6.89l-1.53 4.76-2.47 7.6h-16.01l-2.47-7.6-1.56-4.76c-5.98-1.36-11.59-3.71-16.67-6.89l-4.45 2.27-7.11 3.63-5.67-5.67-5.67-5.64 3.63-7.14 2.3-4.45c-3.2-5.07-5.56-10.69-6.92-16.67l-4.76-1.56-7.6-2.47v-16.01l7.6-2.47 4.76-1.53c1.36-6.01 3.71-11.62 6.92-16.67l-2.3-4.48-3.63-7.11 5.67-5.67 5.67-5.64 7.11 3.63 4.45 2.27c5.07-3.17 10.69-5.56 16.67-6.92l1.56-4.76 2.47-7.6h16.01l2.47 7.6z",
    clipRule: "evenodd",
    fill: "#46bee8",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m313.15 373.95c15.9 0 28.83-12.95 28.83-28.83s-12.93-28.83-28.83-28.83c-15.87 0-28.83 12.95-28.83 28.83s12.95 28.83 28.83 28.83z",
    clipRule: "evenodd",
    fill: "#1180a2",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m179.8 125.32h15.9c-10.23 0-18.62 8.36-18.62 18.6v286.89c-8.96-1.33-15.87-9.1-15.87-18.43v-268.46c0-10.23 8.36-18.6 18.59-18.6z",
    clipRule: "evenodd",
    fill: "#cdd8cf",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.1e690d1c75065be9b295b935596ae32d.svg";
export { ForwardRef as ReactComponent };